<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="550px">
      <v-card width="100%" height="660px">
        <v-toolbar elevation="0" dense>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click="handleClose" class="mr-2">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text
          class="d-flex align-center justify-center flex-column px-0 mx-0"
        >
          <v-col cols="8" class="d-flex justify-center align-center">
            <v-card flat height="350px" width="420px">
              <img src="@/assets/purchaseSuccess.svg" />
            </v-card>
          </v-col>
          <v-col cols="12" class="d-flex justify-center align-center">
            <span class="planSuccess pr-16 mx-10"
              >{{ $t('message.pages.checkout.successPlanAcquired') }}!</span
            >
          </v-col>
          <v-col cols="12" class="d-flex justify-center align-center">
            <span class="planSuccessSubtitle mb-4"
              >{{ $t('message.pages.checkout.planActive') }} <br />
              {{ $t('message.pages.checkout.seeInDashboard') }}.</span
            >
          </v-col>
          <v-col cols="9" class="d-flex justify-center align-center">
            <v-row class="pl-3">
              <v-col cols="12" class="py-0 px-0">
                <v-btn elevation="0" large block @click="handleClose">{{
                  $t('message.concluded')
                }}</v-btn>
              </v-col>
            </v-row>
          </v-col>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
export default {
  name: 'CheckoutDoneModal',
  components: {},
  data: () => ({
    open: false,
  }),
  mounted() {
    this.$root.$on('openCheckoutDoneModal', () => {
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('openCheckoutDoneModal')
  },
  methods: {
    handleClose() {
      this.open = false
    },
  },
}
</script>

<style></style>
